import React from 'react';
import { Globe, Smartphone, Lightbulb, Layers } from 'lucide-react';
import { servicesData } from '../mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  Globe: Globe,
  Smartphone: Smartphone,
  Lightbulb: Lightbulb,
  Layers: Layers
};

const ServicesSection = () => {
  return (
    <section id="servicios" className="py-24 bg-gradient-to-b from-black to-gray-950 relative">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-green-400 font-mono mb-6">
              {'<'} {servicesData.title} {'/>'}
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              {servicesData.description}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {servicesData.services.map((service, index) => {
              const Icon = iconMap[service.icon];
              return (
                <Card
                  key={service.id}
                  className="bg-gray-900/50 border-green-500/30 hover:border-green-400 transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl hover:shadow-green-500/20 backdrop-blur-sm group"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <CardHeader>
                    <div className="w-16 h-16 bg-green-500/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-green-500/20 transition-colors">
                      <Icon className="text-green-400" size={32} />
                    </div>
                    <CardTitle className="text-2xl text-green-400 font-mono">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-gray-300 text-base leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="mt-16 text-center">
            <button
              onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' })}
              className="px-10 py-4 bg-green-500 text-black font-mono font-bold rounded-lg hover:bg-green-400 transition-all transform hover:scale-105 shadow-lg shadow-green-500/50"
            >
              SOLICITAR PRESUPUESTO
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;